import { createFileRoute } from "@tanstack/react-router";
import { prefetchSafety } from "./-pending/prefetch";
import { SafetyPending } from "./-pending/skeletons";
import { SafetyCentre } from "./-safety/SafetyCentre";

export const Route = createFileRoute("/$workspace/$project/safety")({
  staticData: { title: "Safety Centre" },
  // Start the report while the screen's code downloads (and on hover).
  loaderDeps: ({ search }) => ({ env: (search as { env?: string }).env ?? "production" }),
  loader: ({ context, params, deps }) => prefetchSafety(context.queryClient, params.project, deps.env),
  pendingComponent: SafetyPending,
  pendingMs: 150,
  pendingMinMs: 200,
  component: SafetyCentre,
});
